<script>
  import { onDestroy, onMount } from 'svelte';
  import { diff, MergeView } from '@codemirror/merge';
  import { EditorState } from '@codemirror/state';
  import { basicSetup } from 'codemirror';

  let classes = '';

  export { classes as class };

  export let original = '';
  export let modified = '';
  export let gutter = true;
  export let highlightChanges = true;
  export let collapseUnchanged = false;
  export let revertControls = false;
  export let readOnly = false;
  export let changes = [];
  export let onModifiedChange = () => {};

  let element;
  let view;
  let interval = null;

  const getLatestChanges = () => {
    if (view) {
      const newValue = view.b.state.doc.toString();
      const oldValue = modified;

      if (newValue !== oldValue) {
        onModifiedChange(newValue, oldValue);
      }
    }
  };

  onMount(() => {
    view = createEditorView();

    interval = setInterval(getLatestChanges, 1000);
  });

  onDestroy(() => {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }

    view?.destroy();
  });

  const createEditorView = () => {
    return new MergeView({
      a: createEditorState(original),
      b: createEditorState(modified),
      parent: element,
      gutter,
      highlightChanges,
      collapseUnchanged,
      revertControls
    });
  };

  const update = () => {
    if (view) {
      view.destroy();
    }

    view = createEditorView();
  };

  const createEditorState = (value) => {
    return {
      doc: value,
      extensions: [basicSetup, EditorState.readOnly.of(readOnly)]
    };
  };

  const computedChanges = () => {
    const changes = diff(original, modified);

    let deletions = 0;
    let additions = 0;

    changes.forEach((change) => {
      const aRange = change.toA - change.fromA + 1;
      const bRange = change.toB - change.fromB + 1;

      if (aRange > bRange) {
        deletions += aRange - bRange;
      } else if (bRange > aRange) {
        additions += bRange - aRange;
      }
    });

    return {
      additions,
      deletions
    };
  };

  changes = computedChanges();

  $: modified, gutter, highlightChanges, collapseUnchanged, revertControls, update();
</script>

<div class="codemirror-wrapper {classes}" bind:this={element} />

<style lang="scss" src="./merge-view.scss"></style>
